import { PayloadAction } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import { Moment } from 'moment';
import { BulkActionPayloadMap } from 'components/organisms/resource-management/types';
import { asTemplateAllocation } from 'components/organisms/templates/projects/resource-management/utils/as-template-allocation';
import { AllocatedMembers, ProjectTemplateStore } from '../types';

export const allocationSlice = {
  bulkActions: (
    state: ProjectTemplateStore,
    {
      payload: { actionsMap, relativeDate, isHoursPerWeek },
    }: PayloadAction<{
      actionsMap: BulkActionPayloadMap;
      relativeDate: Moment;
      isHoursPerWeek?: boolean;
    }>,
  ): ProjectTemplateStore => {
    const path = `data.${state.activeId}.allocations`;

    let allocations = dotPropImmutable.get(state, path, {});
    const asAllocation = asTemplateAllocation(relativeDate, isHoursPerWeek);

    allocations = Object.values(actionsMap.delete).reduce(
      (result, allocation) => {
        const { [allocation.id]: deletedAllocation, ...rest } = result;

        return rest;
      },
      allocations,
    );
    allocations = Object.values(actionsMap.update).reduce(
      (result, allocation) => {
        const { [allocation.id]: oldAllocation, ...rest } = result;

        return {
          [allocation.id]: asAllocation(allocation),
          ...rest,
        };
      },
      allocations,
    );
    allocations = Object.keys(actionsMap.create).reduce((result, id) => {
      return {
        ...result,
        [id]: asAllocation({ id: parseInt(id, 10), ...actionsMap.create[id] }),
      };
    }, allocations);

    return dotPropImmutable.set(state, path, allocations);
  },
  setAllocatedMembers: (
    state: ProjectTemplateStore,
    { payload: { teams, users } }: PayloadAction<AllocatedMembers>,
  ): ProjectTemplateStore => {
    const path = `data.${state.activeId}.allocatedMembers`;

    return dotPropImmutable.set(state, path, { users, teams });
  },
};
